import { gql } from "@uplift-ltd/apollo";

export type { AllCoursesSlugQueryQuery as AllCoursesSlugQuery } from "./__generated__/AllCourses";

export const ALL_COURSES_SLUG_QUERY = gql`
  query AllCoursesSlugQuery {
    courses(first: 10000) {
      edges {
        node {
          id
          slug
        }
      }
    }
  }
`;
